/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import type {
  MaintenanceVisitPeriod,
  MaintenanceVisitPeriodActionRequest,
  MaintenanceVisitPeriodsListParams,
  MaintenanceVisitPeriodsSummaryRetrieveParams,
  MaintenanceVisitSummaryList
} from '../../model';

import { customFetch } from '../../../liftApiMutator';

export type maintenanceVisitPeriodsListResponse200 = {
  data: MaintenanceVisitPeriod[]
  status: 200
}

export type maintenanceVisitPeriodsListResponseSuccess = (maintenanceVisitPeriodsListResponse200) & {
  headers: Headers;
};
;

export type maintenanceVisitPeriodsListResponse = (maintenanceVisitPeriodsListResponseSuccess)

export const getMaintenanceVisitPeriodsListUrl = (params?: MaintenanceVisitPeriodsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/maintenance-visit-periods/?${stringifiedParams}` : `/api/v1/maintenance-visit-periods/`
}

/**
 * Every period in scope, cell by cell.
 */
export const maintenanceVisitPeriodsList = async (params?: MaintenanceVisitPeriodsListParams, options?: RequestInit): Promise<maintenanceVisitPeriodsListResponse> => {

  return customFetch<maintenanceVisitPeriodsListResponse>(getMaintenanceVisitPeriodsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type maintenanceVisitPeriodsClearNotPerformedCreateResponse200 = {
  data: MaintenanceVisitPeriod
  status: 200
}

export type maintenanceVisitPeriodsClearNotPerformedCreateResponseSuccess = (maintenanceVisitPeriodsClearNotPerformedCreateResponse200) & {
  headers: Headers;
};
;

export type maintenanceVisitPeriodsClearNotPerformedCreateResponse = (maintenanceVisitPeriodsClearNotPerformedCreateResponseSuccess)

export const getMaintenanceVisitPeriodsClearNotPerformedCreateUrl = () => {




  return `/api/v1/maintenance-visit-periods/clear-not-performed/`
}

/**
 * Take back a not-performed mark, leaving the period as the records find it.
 */
export const maintenanceVisitPeriodsClearNotPerformedCreate = async (maintenanceVisitPeriodActionRequest: MaintenanceVisitPeriodActionRequest, options?: RequestInit): Promise<maintenanceVisitPeriodsClearNotPerformedCreateResponse> => {

  return customFetch<maintenanceVisitPeriodsClearNotPerformedCreateResponse>(getMaintenanceVisitPeriodsClearNotPerformedCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(maintenanceVisitPeriodActionRequest)
  }
);}


export type maintenanceVisitPeriodsMarkNotPerformedCreateResponse200 = {
  data: MaintenanceVisitPeriod
  status: 200
}

export type maintenanceVisitPeriodsMarkNotPerformedCreateResponseSuccess = (maintenanceVisitPeriodsMarkNotPerformedCreateResponse200) & {
  headers: Headers;
};
;

export type maintenanceVisitPeriodsMarkNotPerformedCreateResponse = (maintenanceVisitPeriodsMarkNotPerformedCreateResponseSuccess)

export const getMaintenanceVisitPeriodsMarkNotPerformedCreateUrl = () => {




  return `/api/v1/maintenance-visit-periods/mark-not-performed/`
}

/**
 * Record that the scheduled maintenance did not happen.
 *
 * Only where nothing reached us. A period we hold part of the work for is a
 * shortfall to finish, and one still running cannot be answered for yet.
 */
export const maintenanceVisitPeriodsMarkNotPerformedCreate = async (maintenanceVisitPeriodActionRequest: MaintenanceVisitPeriodActionRequest, options?: RequestInit): Promise<maintenanceVisitPeriodsMarkNotPerformedCreateResponse> => {

  return customFetch<maintenanceVisitPeriodsMarkNotPerformedCreateResponse>(getMaintenanceVisitPeriodsMarkNotPerformedCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(maintenanceVisitPeriodActionRequest)
  }
);}


export type maintenanceVisitPeriodsSummaryRetrieveResponse200 = {
  data: MaintenanceVisitSummaryList
  status: 200
}

export type maintenanceVisitPeriodsSummaryRetrieveResponseSuccess = (maintenanceVisitPeriodsSummaryRetrieveResponse200) & {
  headers: Headers;
};
;

export type maintenanceVisitPeriodsSummaryRetrieveResponse = (maintenanceVisitPeriodsSummaryRetrieveResponseSuccess)

export const getMaintenanceVisitPeriodsSummaryRetrieveUrl = (params?: MaintenanceVisitPeriodsSummaryRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/maintenance-visit-periods/summary/?${stringifiedParams}` : `/api/v1/maintenance-visit-periods/summary/`
}

/**
 * One row per elevator instead of one per period.
 */
export const maintenanceVisitPeriodsSummaryRetrieve = async (params?: MaintenanceVisitPeriodsSummaryRetrieveParams, options?: RequestInit): Promise<maintenanceVisitPeriodsSummaryRetrieveResponse> => {

  return customFetch<maintenanceVisitPeriodsSummaryRetrieveResponse>(getMaintenanceVisitPeriodsSummaryRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}


